import { MoreOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { Trans } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import { Dropdown } from 'common/components/antd/Dropdown/Dropdown';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { Tag } from 'common/components/antd/Tag/Tag';
import { EAssetColumnKeys } from 'domains/assets/enums/assets.enum';
import { TAssetStatus } from 'domains/assets/types/assets.types';
import {
  SStatusCell,
} from '../assets.page.styles';
import { TAssetTableRecord, TItemClickEventHandler } from '../types/assets.types';

const getStatusTagColor = (status: TAssetStatus): string => {
  switch (status) {
    case 'live':
      return 'success';
    default:
      return 'processing';
  }
};

export const getColumns = ({
  menuItems,
  onItemActionClick,
}: {
  menuItems?: MenuProps['items'];
  onItemActionClick?: TItemClickEventHandler;
} = {}): ColumnsType<TAssetTableRecord> => [
  {
    title: <Trans i18nKey="assets.table.column.alphaCode.title" />,
    width: 275,
    key: EAssetColumnKeys.AlphaCode,
    dataIndex: EAssetColumnKeys.AlphaCode,
  },
  {
    title: <Trans i18nKey="assets.table.column.assetCode.title" />,
    width: 275,
    key: EAssetColumnKeys.AssetCode,
    dataIndex: EAssetColumnKeys.AssetCode,
  },
  {
    title: <Trans i18nKey="assets.table.column.issuer.title" />,
    width: 275,
    key: EAssetColumnKeys.Issuer,
    dataIndex: EAssetColumnKeys.Issuer,
  },
  {
    title: <Trans i18nKey="assets.table.column.status.title" />,
    width: 212,
    key: EAssetColumnKeys.Status,
    dataIndex: EAssetColumnKeys.Status,
    render: (status, record) =>
      status && (
        <SStatusCell>
          <Tag color={getStatusTagColor(status)}>
            <Trans i18nKey={`assets.table.column.status.${status}`} defaults={status} />
          </Tag>
          <Dropdown
            menu={{
              items: menuItems,
              onClick: onItemActionClick?.({ item: record }),
            }}
            placement="topRight"
          >
            <Button type="text" icon={<MoreOutlined />} />
          </Dropdown>
        </SStatusCell>
      ),
  },
];
